import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { TextField, Tooltip, IconButton } from "@mui/material";
import classes from "../GST-1_Reconciliation/GSTReconciliation.module.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import { TextValidator } from "react-material-ui-form-validator";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { withRouter } from "react-router-dom";
import { canWrite } from '../../../../utils/privilegeUtils';

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";


import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "../../../../axios-order";
import "../../../../asserts/css/Onboarding.css";
import DatePicker from './DatePicker'
import './App.css'

import moment from "moment";
import InputField from "../../../../components/ui/inputField";
import RefreshIcon from "@mui/icons-material/Refresh";
import Modal from "react-bootstrap/Modal";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL



const dateFormat = (value) => {
  if (!value) {
    return "";
  }
  const current_date = new Date(value);
  const yy = current_date.getFullYear().toString();
  const mm = (current_date.getMonth() + 1).toString();
  const dd = current_date.getDate().toString();
  return `${dd}/${mm}/${yy}`;
};
class GSTR1ARepo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerName: "Botmantra",
      file_name: "",
      historyTableOriginalData: [],
      historyTable: [],
      loading: false,
      modalShow: false,
      customRoundOff: null,
      threshold_value: 0,
      roundOff: 0,
      loaderForTable: false,
      fromMonthYearDisplay: '',
      fromToYearDisplay: '',
      status: false,
      data: [],
      errorMessage: '',
      showBoxWrapper: false,
      responseData: '',
      displayResponse: false,
      taskId: '',
      isSubmitting: false,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
      downloadingId: null,
    };
  }

  componentDidMount() {
    // this.handleRefresh();
    // this.fetchData();
    this.getDetails();
  }

  fetchData = () => {
    axios
      .get(`${apiUrl}/mydemo/gstDownload/gstrclientstatus/${localStorage.getItem('business_entity_id')}`)
      .then(response => {
        this.setState({ data: response.data });
        console.log(response);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  handleSnackbarOpen = (message, severity) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
    });
  };
  handleBackNavigation = () => {
    this.props.history.push('/repoCards');
  };

  extractAutoTaskId = response => {
    const autoTaskIdPattern = /Auto Task id :(\d+)/;
    const match = response.match(autoTaskIdPattern);
    return match ? match[1] : null;
  };

  handleRefresh = () => {
    axios
      .get(`${apiUrl}/mydemo/gstDownload/gstrclientstatus/${localStorage.getItem('business_entity_id')}`)
      .then(response => {
        this.setState({ data: response.data });
        console.log(response);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  handleClick = (first_col, second_col) => {
    axios
      .post(`${apiUrl}/table/`, { first_col, second_col })
      .then(response => {
        console.log('Data sent to backend:', response.data);
      })
      .catch(error => {
        console.error('Error sending data:', error);
      });
  };

  onSubmitHandler = (event) => {
    event.preventDefault();
    this.setState({ isSubmitting: true });

    const { file_name, fromMonthYearDisplay, fromToYearDisplay, GSTJsonfFile } = this.state;

    if (file_name && GSTJsonfFile) {

      this.setState({ loading: true });
      axios
        .post(`/arc/gst_repo`, {
          file: `${GSTJsonfFile}`,
          business_entity_id: localStorage.getItem("business_entity_id"),
        })
        .then((res) => {
          if (
            typeof res.data.error !== "undefined" ||
            typeof res.data === "undefined"
          ) {
            this.handleSnackbarOpen("File processing failed.", "error");
          } else {
            this.getDetails();
            this.setState({ loading: false, file_name: "" });
            this.handleSnackbarOpen("File processing completed.", "success");
          }
        })
        .catch((error) => {
          axios
            .get(
              `/get_gstr1a_repository_log/${localStorage.getItem("business_entity_id")}`
            )
            .then((res) => {
              if (typeof res.data === "undefined") {
              } else {
                this.setState({
                  historyTable: res.data.data,
                  historyTableOriginalData: res.data.data,
                });
              }
            });
          this.setState({ loading: false, file_name: "" });
          this.handleSnackbarOpen(
            `Error: ${error?.response?.data?.message}`,
            "error"
          );
        })
        .finally(() => {
          this.setState({ isSubmitting: false });
        });
    }
    else if (fromMonthYearDisplay && fromToYearDisplay) {
      const url = `${apiUrl}/gstr1a_repository_auto_download`;
      const entity_id = localStorage.getItem('business_entity_id');

      const payload = {
        business_entity_id: entity_id,
        gstin: localStorage.getItem('gst') || '',
        fromRetPeriod: fromMonthYearDisplay,
        toRetPeriod: fromToYearDisplay,
      };

      axios
        .post("/gstr1a_repository_auto_download", payload)
       .then((response) => {
          console.log(response);
          const responseData = response.data;
          if (responseData.message_type && responseData.message) {
            this.handleSnackbarOpen(responseData.message, responseData.message_type);
          } else if (responseData.status === 'success' && responseData.message) {
            this.handleSnackbarOpen(responseData.message, 'success');
          } else if (responseData.status === true && responseData.message) {
            this.handleSnackbarOpen(responseData.message, 'success');
          } else if (responseData.status === false && responseData.message) {
            this.handleSnackbarOpen(responseData.message, 'error');
          } else {
            this.handleSnackbarOpen('An unexpected response was received.', 'error');
          }
          this.getDetails();
        })
        .catch((error) => {
          console.log(error);
          this.handleSnackbarOpen(
            "Error occurred during download. Please try again later.",
            "error"
          );
        })
        .finally(() => {
          this.setState({ isSubmitting: false });
        });
    } else {
      this.handleSnackbarOpen("Please provide either a file or select date range.", "error");
      this.setState({ isSubmitting: false });
    }
  };

  inputHandlerFromPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    this.setState({ fromMonthYearDisplay: formattedDate });
    console.log(formattedDate)
    this.inputHandlerToPicker(v)
  };

  inputHandlerToPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    this.setState({ fromToYearDisplay: formattedDate });
    console.log(formattedDate)
  };

  handleSearchInputChange = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  globalSearch = (event) => {
    let { searchInput } = this.state;

    let searchAdminData = this.state.historyTableOriginalData.filter(
      (value) => {
        const query = searchInput.toLowerCase();
        return (
          String(value.gstin).toLowerCase().indexOf(query) >= 0 ||
          String(value.from_period).toLowerCase().indexOf(query) >= 0 ||
          String(value.to_period).toLowerCase().indexOf(query) >= 0 ||
          String(value.financial_year).toLowerCase().indexOf(query) >= 0 ||
          String(value.status).toLowerCase().indexOf(query) >= 0 ||
          String(value.remarks).toLowerCase().indexOf(query) >= 0
        );
      }
    );
    this.setState({ historyTable: searchAdminData });
  };

  fileUploader = (event) => {
    if (event.target.files[0]) {
      const file_data = event.target.files[0];
      let fileName = file_data.name;
      this.setState({ file_name: fileName });
      const reader = new FileReader();
      reader.readAsDataURL(file_data);
      const dis = this;
      reader.onload = function () {
        let file_value = reader.result;
        dis.setState({ GSTJsonfFile: file_value });
      };
      document.getElementById("file_value").value = null;
    }
  };

  getDetails = () => {
    this.setState({ loaderForTable: true });
    axios
      .get(`/get_gstr1a_repository_log/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (typeof res.data === "undefined") {
          this.setState({ loaderForTable: false });
        } else {
          this.setState({
            loaderForTable: false,
            historyTable: res.data.data,
            historyTableOriginalData: res.data.data,
          });
        }
      })
      .catch(() => this.setState({ loaderForTable: false }));
  };

  handleCloseLoader = () => {
    this.setState({ loading: false });
  };

  historyTableHeader = () => {
    const tableHeader = [
      "GSTIN",
      "From Period",
      "To Period",
      "Financial Year",
      "Uploaded DateTime",
      "Status",
      "Remarks",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  };

  downloadBase64File = (contentType, base64Data, fileName) => {
    console.log(contentType, base64Data, fileName);
    const linkSource = `data:${contentType};base64,${base64Data?.split("'")[1]
      }`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  handleDownloadJson = (id, gstr1_status, gstr1_reason) => {
    if (gstr1_status === 'Pass') {
      const contentType = 'application/json';
      const filename = 'GSTR1a_Report.json';

      this.setState({ downloadingId: id });

      axios
        .get(`/download_gstr1a_repository/${id}`)
        .then((res) => {
          this.downloadBase64File(contentType, res.data.records, filename);
        })
        .catch((err) => {
          this.setState({
            snackbarMessage: gstr1_reason,
            snackbarOpen: true,
          });
        })
        .finally(() => {
          this.setState({ downloadingId: null });
        });
    } else {
      this.setState({
        snackbarMessage: gstr1_reason,
        snackbarOpen: true,
      });
    }
  };

  historyTableData = () => {
    const { loaderForTable, historyTable } = this.state;

    if (loaderForTable) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={7}
          >
            Loading…Please wait
          </td>
        </tr>
      );
    } else if (this.state?.historyTable?.length >= 1) {
      return this.state?.historyTable?.map((tableData, index) => {
        const {
          gstin,
          from_period,
          to_period,
          financial_year,
          uploaded_datetime,
          status,
          remarks,
        } = tableData;

        return (
          <tr key={index}>
            <td>{gstin}</td>
            <td>{from_period}</td>
            <td>{to_period}</td>
            <td>{financial_year}</td>
            <td>{uploaded_datetime}</td>
            <td>
              <span style={{ color: status === 'Succeeded' ? 'green' : status === 'Fail' ? 'red' : '#e6a817' }}>
                {status}
              </span>
            </td>
            <td>
              <VisibilityOutlinedIcon
                className="action-icon-button showIcon"
                style={{ cursor: 'pointer', color: status === 'Fail' ? 'red' : '#1976d2' }}
                onClick={() => this.handleSnackbarOpen(remarks || 'No remarks available', status === 'Fail' ? 'error' : 'success')}
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={7}>
            No data found!
          </td>
        </tr>
      );
    }
  };

  newReconModalClose = () => {
    this.setState({
      file_name: "",
      fromMonthYearDisplay: "",
      fromToYearDisplay: "",
    });
  };
  
   handleRefreshHistory = () => {
    this.getDetails();
  };

  render() {
    const { fromMonthYearDisplay, fromToYearDisplay, isSubmitting } = this.state;
    const { data, responseData, displayResponse } = this.state;
    const business_entity_id = localStorage.getItem('business_entity_id');

    return (
      <React.Fragment>
        <div style={{
          padding: "15px 20px",
          backgroundColor: "#f5f5f5"
        }}>
          <Tooltip title="Back" arrow>
            <IconButton
              onClick={this.handleBackNavigation}
              sx={{
                borderRadius: '50%',
                padding: '6px',
                color: '#263238',
                fontSize: '20px',
                backgroundColor: '#ffffff',
                height: '36px',
                width: '36px',
                '&:hover': {
                  backgroundColor: '#455a64',
                  color: '#ffffff',
                },
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                transition: 'background-color 0.3s ease',
              }}
            >
              <ArrowBackIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Tooltip>
        </div>
        {canWrite("GSTR1-POST RECON") && (
        <BoxWrapper
          boxTitle={
            <span style={{
              fontWeight: 600,
              display: "block",
              // textAlign: "center",
              width: "100%",
              paddingRight: "20px",
            }}>
              GSTR-1A Auto Download
            </span>
          }
        >
          {/* <BoxWrapper
          boxTitle={
            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              paddingRight: "20px",
              position: "relative"
            }}>
              <span style={{ fontWeight: 600, color: "#000" }}>
                GSTR-1A Return 
              </span>
              <span style={{ fontWeight: 600, position: "absolute", left: "35%", transform: "translateX(-50%)" }}>
                GSTR-1A Auto Download
              </span>
            </div>
          }
        > */}
          <ValidatorForm
            ref="form"
            onSubmit={this.onSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '40px' }}>
                {/* <div style={{ minWidth: '100px' }}>
                    <label
                      className="button-primary"
                      style={{
                        width: "100%",
                        textAlign: "center",
                      cursor: fromMonthYearDisplay ? "not-allowed" : "pointer",
                      padding: "8px",
                      display: 'block',
                      opacity: fromMonthYearDisplay ? 0.5 : 1,
                      pointerEvents: fromMonthYearDisplay ? 'none' : 'auto'
                      }}
                    >
                    Upload
                      <input
                        id="file_value"
                        name="GSTJsonfFile"
                        accept="application/json"
                        type="file"
                        hidden
                        onChange={this.fileUploader}
                      disabled={!!fromMonthYearDisplay}
                      />
                    </label>
                </div>
                <div style={{ flex: '0 0 350px' }}>
                    <TextValidator
                      placeholder="Choose file"
                      value={this.state.file_name}
                      name="GSTJson_file_uploader"
                      inputProps={{
                        readOnly: true,
                      }}
                      fullWidth
                      size="small"
                    disabled={!!fromMonthYearDisplay}
                    style={{ opacity: fromMonthYearDisplay ? 0.5 : 1 }}
                    />
                </div> */}

                <div style={{ flex: '0 0 300px', opacity: this.state.file_name ? 0.5 : 1 }}>
                  <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                    Please Select From Month and Year <span style={{ color: 'red' }}>*</span>:
                  </label>
                  <DatePicker
                    views={['year', 'month']}
                    placeholder="From Year to Month"
                    format="MM/yyyy"
                    value={fromMonthYearDisplay}
                    onChange={this.inputHandlerFromPicker}
                    disabled={!!this.state.file_name}
                  />
                </div>
                <div style={{ flex: '0 0 300px', opacity: this.state.file_name ? 0.5 : 1 }}>
                  <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                    Please Select To Month and Year <span style={{ color: 'red' }}>*</span>:
                  </label>
                  <DatePicker
                    views={['year', 'month']}
                    placeholder="From Year to Month"
                    format="MM/yyyy"
                    value={fromToYearDisplay}
                    onChange={this.inputHandlerToPicker}
                    disabled={true}
                  />
                </div>
                <div style={{ display: 'flex', gap: '5px', marginLeft: '-25px' }}>
                  <div style={{ minWidth: '100px' }}>
                    <button
                      className="button-primary"
                      type="submit"
                      style={{ width: '100%', padding: '8px' }}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>

                  <div style={{ minWidth: '100px' }}>
                    <button
                      type="button"
                      className="button-outlined-secondary"
                      onClick={this.newReconModalClose}
                      style={{ width: '100%', padding: '8px' }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ValidatorForm>
        </BoxWrapper>
        )}

      <BoxWrapper
          boxTitle={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
              <span>History</span>
              <button
                type="button"
                onClick={this.handleRefreshHistory}
                disabled={this.state.loaderForTable}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  border: "1px solid #263238",
                  borderRadius: "4px",
                  background: "#ffffff",
                  color: "#263238",
                  padding: "4px 10px",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: this.state.loaderForTable ? "not-allowed" : "pointer",
                  opacity: this.state.loaderForTable ? 0.6 : 1,
                }}
              >
                <RefreshIcon fontSize="small" />
                Refresh
              </button>
            </div>
          }
          enableSearchInput={true}
          searchInputPlaceholder="Search..."
          searchInputOnchange={this.handleSearchInputChange}
        >
          <div className="responsive-table">
            <table className="custome-table">
              <tbody>
                <tr>{this.historyTableHeader()}</tr>
                {this.historyTableData()}
              </tbody>
            </table>
          </div>
        </BoxWrapper>

        {responseData && (
          <div>
            <p style={{ fontSize: '20px', color: 'green' }}>DOWNLOADED GSTR DATA</p>
            <p>{responseData}</p>
          </div>
        )}

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleSnackbarClose}
          style={{ maxWidth: '25%' }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.handleSnackbarClose}
            severity={this.state.snackbarSeverity}
          >
            {this.state.snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </React.Fragment>
    );
  }
}
export default withRouter(GSTR1ARepo);